
import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Michael Chen',
    role: 'Production Manager',
    company: 'Artisan Crafts Co.',
    country: 'USA',
    image:
      'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20portrait%20headshot%20wearing%20suit%20neutral%20gray%20background%20corporate%20photo%20high%20quality&width=100&height=100&seq=test1&orientation=squarish',
    content:
      'The CM1390E has transformed our production line. We have increased output by 40% while maintaining exceptional quality. The support team is incredibly responsive.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Sarah Williams',
    role: 'Owner',
    company: 'Creative Signs Ltd.',
    country: 'UK',
    image:
      'https://readdy.ai/api/search-image?query=professional%20caucasian%20businesswoman%20portrait%20headshot%20blonde%20hair%20neutral%20gray%20background%20corporate%20photo%20high%20quality&width=100&height=100&seq=test2&orientation=squarish',
    content:
      'Best investment we have made for our signage business. The precision and speed are unmatched. Customer service helped us every step of the way.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Hans Mueller',
    role: 'Technical Director',
    company: 'Precision Works GmbH',
    country: 'Germany',
    image:
      'https://readdy.ai/api/search-image?query=professional%20european%20businessman%20portrait%20headshot%20middle%20aged%20neutral%20gray%20background%20corporate%20photo%20high%20quality&width=100&height=100&seq=test3&orientation=squarish',
    content:
      'German engineering standards met. The build quality and precision of Redsail machines exceed our expectations. Highly recommended for industrial use.',
    rating: 5,
  },
];

const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Guard against an empty testimonials array
  if (!testimonials.length) {
    return null;
  }

  // Ensure activeIndex is always within bounds
  const safeIndex = Math.min(Math.max(activeIndex, 0), testimonials.length - 1);
  const { rating, content, image, name, role, company, country } = testimonials[safeIndex];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-emerald-500 font-semibold text-sm tracking-wider uppercase">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3">
            Trusted Worldwide
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl shadow-gray-200/50">
            <div className="flex items-center gap-1 mb-6">
              {[...Array(rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-xl"></i>
              ))}
            </div>

            <p className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-8">
              &quot;{content}&quot;
            </p>

            <div className="flex items-center gap-4">
              <img
                src={image}
                alt={name}
                className="w-14 h-14 rounded-full object-cover"
                onError={(e) => {
                  // Fallback image if the provided URL fails
                  e.currentTarget.src =
                    'https://via.placeholder.com/100?text=No+Image';
                }}
              />
              <div>
                <div className="font-bold text-gray-900">{name}</div>
                <div className="text-sm text-gray-500">
                  {role} at {company}
                </div>
                <div className="text-xs text-emerald-500 font-medium mt-1">{country}</div>
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-3 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === safeIndex
                    ? 'bg-emerald-500 w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Show testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
